import { render, staticRenderFns } from "./PostGalleryShowMore.vue?vue&type=template&id=a638259e"
import script from "./PostGalleryShowMore.vue?vue&type=script&lang=ts"
export * from "./PostGalleryShowMore.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports